import { DialogActions, DialogContent, DialogProps } from "@mui/material";
import { Button, PageHeader } from "common";
import Dialog from "components/DraggableDialog/DraggableDialog";
import I18n from "i18n";
import { BookingDocumentType } from "./bookingDocumentApi";
import BookingDocumentList from "./BookingDocumentList";

export interface BookingDocumentListModalProps extends DialogProps {
  type?: BookingDocumentType;
}

export default function BookingDocumentListModal({
  type,
  ...props
}: BookingDocumentListModalProps) {
  return (
    <Dialog maxWidth="md" fullWidth {...props}>
      <PageHeader title="Forgatókönyvek" onClose={props.onClose} />
      <DialogContent>
        <BookingDocumentList type={type} showHeader={false} />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={
            props.onClose
              ? () => props.onClose && props.onClose({}, "backdropClick")
              : undefined
          }
        >
          {I18n.t("App.close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
